import {
  Flex,
  Stack,
  Skeleton as BackyardSkeleton,
  Spacer,
  SimpleGrid,
} from '@backyard-ui/core';

export default function Skeleton() {
  return (
    <Flex direction="column" data-testid="skeleton">
      <SimpleGrid gapY="10" columns={{ sm: 1, md: 2 }} data-testid="resume">
        <Stack direction="column">
          {new Array(5).fill({}).map((_, i) => (
            <Flex align="center" key={i}>
              <BackyardSkeleton height="20px" width="20px" radius="full" />
              <Spacer size="2" />
              <BackyardSkeleton height="16px" width="276px" />
            </Flex>
          ))}
        </Stack>
        <Flex direction="column">
          <BackyardSkeleton height="16px" width="200px" />
          <Spacer size="6" axis="vertical" />
          <Flex align="center">
            <BackyardSkeleton height="50px" width="50px" radius="full" />
            <Spacer size="4" />
            <BackyardSkeleton height="16px" width="200px" />
          </Flex>
        </Flex>
      </SimpleGrid>
      <Spacer size="20" axis="vertical" />
      <SimpleGrid gapY="10" columns={{ sm: 1, md: 2 }} data-testid="resume">
        {new Array(2).fill({}).map((_, i) => (
          <Flex direction="column" key={i}>
            <BackyardSkeleton height="16px" width="230px" />
            <Spacer size="8" axis="vertical" />
            <BackyardSkeleton height="16px" width="260px" />
            <Spacer size="4" axis="vertical" />
            <BackyardSkeleton height="16px" width="400px" />
            <Spacer size="4" axis="vertical" />
            <BackyardSkeleton height="16px" width="220px" />
          </Flex>
        ))}
      </SimpleGrid>
    </Flex>
  );
}
